import axios from 'axios';
export class WelcomeService {
  constructor() {}

  static async getWelcomeVideoAgent(query: string) {
    const sessionId =
      sessionStorage.getItem('welcomeSessionId') || crypto?.randomUUID();
    const { data } = await axios.post(
      `${import.meta.env.VITE_APP_BASE_URL}/welcome/`,
      {
        query,
        session_id: sessionId,
      }
    );
    return data;
  }
}
